import { createSlice } from "@reduxjs/toolkit";
// import storage from "../../services/storage";

//const token = storage.get("classToken") || "";

const initialState = {
  activetab: null,
};

const slice = createSlice({
  name: "classTabs",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activetab = action.payload;
    },
  },
});

export const { setActiveTab } = slice.actions;
export default slice.reducer;
